module.exports = __webpack_public_path__ + "img/bg_02.ef6f94b1.png";